import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {reduxForm, initialize, formValueSelector, change} from 'redux-form';
import format from 'date-fns/format';
import {Forms} from '../../../../shared/models/forms';
import View from './view';
import {FilterForm, ViewProps, Props} from './model';
import {dateFormats, dateNewsFrom, dateNewsTo} from '../../../../shared/constants/date';
import {applyNewsFilter} from '../../../../redux/actions/news';
import {setFilterModalVisible} from '../../../../redux/actions/runtime/news';
import {defaults} from '../../../../shared/constants/defaults';

const initialFormState: FilterForm = {
  all: true,
  from: dateNewsFrom,
  to: dateNewsTo,
};

const Form = reduxForm<FilterForm, ViewProps>({form: Forms.newsFilter, destroyOnUnmount: false})(View);
const selector = formValueSelector(Forms.newsFilter);

export const Filter = (viewProps: Props) => {
  const dispatch = useDispatch();
  const formData: FilterForm = useSelector((state) => selector(state, 'from', 'to', 'all'));

  React.useEffect(() => {
    if (!Object.keys(formData).length) {
      dispatch(initialize(Forms.newsFilter, initialFormState));
    }
  }, [formData]);

  const onSubmit = React.useCallback(() => {
    const params = formData.all
      ? undefined
      : {
          from: format(formData.from, dateFormats.apiDate),
          to: format(formData.to, dateFormats.apiDate),
          perPage: defaults.newsPageSize,
        };

    dispatch(applyNewsFilter(params));
    dispatch(setFilterModalVisible(false));
  }, [formData]);

  const onShowAllChange = React.useCallback(
    (value: any) => {
      if (value) {
        dispatch(change(Forms.newsFilter, 'from', dateNewsFrom));
        dispatch(change(Forms.newsFilter, 'to', dateNewsTo));
      }
    },
    [formData],
  );

  const onDateChange = React.useCallback(() => {
    dispatch(change(Forms.newsFilter, 'all', false));
  }, []);

  const onClose = () => dispatch(setFilterModalVisible(false));

  if (!Object.keys(formData).length) {
    return null;
  }
  return React.createElement(Form, {formData, onSubmit, onShowAllChange, onDateChange, onClose, ...viewProps});
};
